import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setupAPIs } from "../setupUtils";
import dayjs from "dayjs";
import { saveAs } from "file-saver";

const initialProductGroup = {
   isEdit: true,
   isLoading: false,

   countries: [],
   country: "",
   countryID: "",

   productGroups: [],
   productGroupName: "",
   eProductGroupName: "",
   productGroupID: "",
   productGroup: null,

   fromDate: dayjs().add(1, "day"),
   toDate: dayjs("2099-12-31T00:00:00.000Z"),

   status: "None",

   skus: [],
   selectedSKUs: [],

   searchedPGName: "",

   apiResponse: null,

   comments: "",

   createPGName: "",

   createFromDate: dayjs().add(1, "day"),
   createToDate: dayjs("2099-12-31T00:00:00.000Z"),
   createIndDateUpdated: false,
   createEditStartEndDateModalOpened: false,

   createMessage: "", 
   createMessageSeverity: "", 
   createMessageOpen: false,

   editMessage: "",
   editMessageSeverity: "",
   editMessageOpen: false,

   files: [],
	is_sku_refresh : false,
   is_refresh : false
};

export const getUserCountries = createAsyncThunk(
   "productGroup/getUserCountries",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url = setupAPIs.getUserCountries + `userid=${data.userID}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getPGForCountry = createAsyncThunk(
   "productGroup/getPGForCountry",
   async ({ countryID, productGroupName }, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url =
         setupAPIs.getPGForCountry +
         `CountryID=${countryID}&ProductGroupName=${productGroupName}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getPGDetail = createAsyncThunk(
   "productGroup/getPGDetail",
   async ({ productGroupID }, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      if (token) {
         headers.append("Authorization", `Bearer ${token}`);
      }
      const options = {
         headers,
      };
      const url = setupAPIs.getPGDetail + `ProductGroupID=${productGroupID}`;
      const response = await fetch(url, options);
      const jsonData = await response.json();
      return jsonData;
   }
);

export const getProductGroups = createAsyncThunk(
   "productGroup/getProductGroups",
   async ({ countryID, productGroupName }, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url =
         setupAPIs.getProductGroups +
         `CountryID=${countryID}&ProductName=${productGroupName}`;
      try {
         const response = await fetch(url, {
            method: "GET",
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const submitProductGroupEdit = createAsyncThunk(
   "productGroup/submitProductGroupEdit",
   async (formdata, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.submitProductGroupEdit;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: formdata,
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const submitProductGroupCreate = createAsyncThunk(
   "productGroup/submitProductGroupCreate",
   async (formdata, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.submitProductGroupCreate;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: formdata,
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const saveProductGroupEdit = createAsyncThunk(
   "productGroup/saveProductGroupEdit",
   async (formdata, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.saveProductGroupEdit;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: formdata,
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const saveProductGroupCreate = createAsyncThunk(
   "productGroup/saveProductGroupCreate",
   async (formdata, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.saveProductGroupCreate;
      try {
         const response = await fetch(url, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
            body: formdata,
         });
         const jsonData = await response.json();
         return jsonData;
      } catch (error) {
         console.error("Error: ", error);
      }
   }
);

export const downloadAttachment = createAsyncThunk(
   "productGroup/downloadAttachment",
   async (obj, thunkAPI) => {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = setupAPIs.downloadAttachment + `fileName=${obj.fileName}`;
      try {
         const response = await fetch(url, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               Accept: "application/json",
            },
         });
         const res = await response.blob();
         const fileName = `${obj.fileName}`;
         saveAs(res, fileName);
         return res;
         } catch (error) {
            console.error("Error: ", error);
         }
      }     
);

const productGroupSetupSlice = createSlice({
   name: "productGroupSetup",
   initialState: initialProductGroup,
   reducers: {
      setPGState: {
         prepare(stateName, value) {
            return {
               payload: { stateName, value },
            };
         },
         reducer(state, action) {
            const { stateName, value } = action.payload;
            state[stateName] = value;
         },
      },
      resetAllStates(state, action) {
         if (action.payload.edit === true) {
            state.isEdit = true;
         }
         state.isLoading = false;

         if (
            !(
               action.payload.edit === true &&
               action.payload.go &&
               action.payload.go === true
            )
         ) {
            state.country = "";
            state.countryID = "";
            state.productGroupName = "";
            state.selectedSKUs = [];
            state.productGroupID = "";
         }
         state.eProductGroupName = "";
         state.productGroup = null;

         state.fromDate = dayjs().add(1, "day");
         state.toDate = dayjs("2099-12-31T00:00:00.000Z");

         state.status = "None";

         state.skus = [];
         state.is_refresh = false;
         

         state.searchedPGName = "";

         state.apiResponse = null;

         state.comments = "";

         state.createPGName = "";

         state.createFromDate = dayjs().add(1, "day");
         state.createToDate = dayjs("2099-12-31T00:00:00.000Z");
         state.createIndDateUpdated = false;
         state.createEditStartEndDateModalOpened = false;
         state.files = [];
         state.createMessageOpen = false;
         state.editMessageOpen = false;
      },
      addFile(state, action) {
			console.log(action.payload);
			const updatedFiles = [...state.files, action.payload];
			console.log(updatedFiles);
			state.files = updatedFiles;
		},
      deleteFile(state, action) {
			const { filePath } = action.payload;
			const updatedFiles = state.files.filter((file) => file.filePath !== filePath);
			state.files = updatedFiles;
		},
   },
   extraReducers: (builder) => {
      builder
         .addCase(getUserCountries.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getUserCountries.fulfilled, (state, action) => {
            state.isLoading = false;
            state.countries = action.payload;
         })
         .addCase(getUserCountries.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from GetUserCountries", action.error.message);
         })

         .addCase(getPGForCountry.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getPGForCountry.fulfilled, (state, action) => {
            state.isLoading = false;
            state.productGroups = action.payload;
            if(action.payload.length === 0) {
               state.editMessage = "No product group found.";
               state.editMessageSeverity = "info";
               state.editMessageOpen = true;
            }
         })
         .addCase(getPGForCountry.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getPGForCountry", action.error.message);
         })

         .addCase(getPGDetail.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getPGDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            state.productGroup = action.payload;
         })
         .addCase(getPGDetail.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getPGDetail", action.error.message);
         })

         .addCase(getProductGroups.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(getProductGroups.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.length !== 0) {
               if (state.selectedSKUs.length > 0) {
                  let tempSKUs = action.payload;
                  let skus = [];
                  for (let i = 0; i < tempSKUs.length; ++i) {
                     const item = tempSKUs[i];
                     let itemPresent = false;
                     for (let j = 0; j < state.selectedSKUs.length; ++j) {
                        const selItem = state.selectedSKUs[j];
                        if (selItem.productID === item.productID) {
                           itemPresent = true;
                           break;
                        }
                     }
                     if (!itemPresent) {
                        skus.push(item);
                     }
                  }
                  state.skus = skus;
               } else {
                  state.skus = action.payload;
               }   
            }
            else {
               if(state.isEdit === false) {
                  state.skus = [];
                  state.createMessageOpen = true;
                  state.createMessage = "No records Found";
                  state.createMessageSeverity = "info";
               }else{
                  state.skus = [];
                  state.editMessageOpen = true;
                  state.editMessage = "No records Found";
                  state.editMessageSeverity = "info";
               }
            }
         })
         .addCase(getProductGroups.rejected, (state, action) => {
            state.isLoading = false;
            console.error("Error from getProductGroups", action.error.message);
         })

         .addCase(submitProductGroupCreate.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(submitProductGroupCreate.fulfilled, (state, action) => {
            console.log("submitProductGroupCreate", action.payload);
            state.apiResponse = action.payload;
            if(state.isEdit === false) {
               if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse === "Successfull"
               ) {
                  state.createMessage = "Product group submitted successfully";
                  state.createMessageSeverity = "success";
               } else if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse !== "Successfull"
               ) {
                  state.createMessage = state.apiResponse;
                  state.createMessageSeverity = "error";
               } else if (state.apiResponse === -1) {
                  state.createMessage =
                     "Validation error occured while submitting product group";
                  state.createMessageSeverity = "error";
               } else {
                  state.createMessage =
                     "Some error occured while submitting product group";
                  state.createMessageSeverity = "error";
               }
               state.createMessageOpen = true;
            }
            else {
               if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse === "Successfull"
               ) {
                  state.editMessage = "Product group submitted successfully";
                  state.editMessageSeverity = "success";
               } else if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse !== "Successfull"
               ) {
                  state.editMessage = state.apiResponse;
                  state.editMessageSeverity = "error";
               } else if (state.apiResponse === -1) {
                  state.editMessage =
                     "Validation error occured while submitting product group";
                  state.editMessageSeverity = "error";
               } else {
                  state.editMessage =
                     "Some error occured while submitting product group";
                  state.editMessageSeverity = "error";
               }
               state.editMessageOpen = true;
            }
            
            state.isLoading = false;
         })
         .addCase(submitProductGroupCreate.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from submitProductGroupCreate",
               action.error.message
            );
         })

         .addCase(submitProductGroupEdit.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(submitProductGroupEdit.fulfilled, (state, action) => {
            console.log("submitProductGroupEdit", action.payload);
            state.apiResponse = action.payload;
            if(state.isEdit === false) {
               if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse === "Successfull"
               ) {
                  state.createMessage = "Product group submitted successfully";
                  state.createMessageSeverity = "success";
               } else if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse !== "Successfull"
               ) {
                  state.createMessage = state.apiResponse;
                  state.createMessageSeverity = "error";
               } else if (state.apiResponse === -1) {
                  state.createMessage =
                     "Validation error occured while submitting product group";
                  state.createMessageSeverity = "error";
               } else {
                  state.createMessage =
                     "Some error occured while submitting product group";
                  state.createMessageSeverity = "error";
               }
               state.createMessageOpen = true;
            }
            else {
               if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse === "Successfull"
               ) {
                  state.editMessage = "Product group submitted successfully";
                  state.editMessageSeverity = "success";
               } else if (
                  typeof state.apiResponse === "string" &&
                  state.apiResponse !== "Successfull"
               ) {
                  state.editMessage = state.apiResponse;
                  state.editMessageSeverity = "error";
               } else if (state.apiResponse === -1) {
                  state.editMessage =
                     "Validation error occured while submitting product group";
                  state.editMessageSeverity = "error";
               } else {
                  state.editMessage =
                     "Some error occured while submitting product group";
                  state.editMessageSeverity = "error";
               }
               state.editMessageOpen = true;
            }
            
            state.isLoading = false;
         })
         .addCase(submitProductGroupEdit.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from submitProductGroupEdit",
               action.error.message
            );
         })

         .addCase(saveProductGroupCreate.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(saveProductGroupCreate.fulfilled, (state, action) => {
            console.log("saveProductGroupCreate", action.payload);
            state.apiResponse = action.payload;
            if(state.isEdit === false) {
               if (typeof state.apiResponse === "string") {
                  state.createMessage = state.apiResponse;
                  state.createMessageSeverity = "error";
               } else {
                  state.createMessage = "Product group saved successfully";
                  state.createMessageSeverity = "success";
               }
               state.createMessageOpen = true;
            }
            else {
               if (typeof state.apiResponse === "string") {
                  state.editMessage = state.apiResponse;
                  state.editMessageSeverity = "error";
               } else {
                  state.editMessage = "Product group saved successfully";
                  state.editMessageSeverity = "success";
               }
               state.editMessageOpen = true;
            }
            state.isLoading = false;
         })
         .addCase(saveProductGroupCreate.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from saveProductGroupCreate",
               action.error.message
            );
         })

         .addCase(saveProductGroupEdit.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(saveProductGroupEdit.fulfilled, (state, action) => {
            state.apiResponse = action.payload;
            console.log("saveProductGroupCreate", action.payload);
            state.apiResponse = action.payload;
            if(state.isEdit === false) {
               if (typeof state.apiResponse === "string") {
                  state.createMessage = state.apiResponse;
                  state.createMessageSeverity = "error";
               } else {
                  state.createMessage = "Product group saved successfully";
                  state.createMessageSeverity = "success";
               }
               state.createMessageOpen = true;
            }
            else {
               if (typeof state.apiResponse === "string") {
                  state.editMessage = state.apiResponse;
                  state.editMessageSeverity = "error";
               } else {
                  state.editMessage = "Product group saved successfully";
                  state.editMessageSeverity = "success";
               }
               state.editMessageOpen = true;
            }
            
            state.isLoading = false;
         })
         .addCase(saveProductGroupEdit.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from saveProductGroupEdit",
               action.error.message
            );
         })
         
         .addCase(downloadAttachment.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(downloadAttachment.fulfilled, (state, action) => {
            state.isLoading = false;
         })
         .addCase(downloadAttachment.rejected, (state, action) => {
            state.isLoading = false;
            console.error(
               "Error from downloadAttachment",
               action.error.message
            );
         })
   },
});

export const { setPGState, resetAllStates, addFile, deleteFile } = productGroupSetupSlice.actions;

export default productGroupSetupSlice.reducer;
